module.exports = __webpack_public_path__ + "img/NO913460715.2143d2a8.png";